<template>
    <div class="flex gap-2 items-center">
        <UButton
            v-if="actionable"
            size="sm"
            label="Behandle"
            :disabled="assignment.status === AssignmentStatus.Deleted"
            @click="handleAction"
        />
        <assignment-dropdown-actions
            v-if="assignment"
            class="ml-auto"
            :assignment
            :params
        />
    </div>
</template>

<script setup lang="ts">

import {Assignment, AssignmentCellRenderParams, AssignmentStatus} from '@/assignments/Assignment.type'
import {computed, inject, Ref} from 'vue'
import {SubAccountCreatable} from '@/assignments/SubAccountCreatable/SubAccountCreatable.type'
import {handleSubAccountCreatable} from '@/assignments/SubAccountCreatable/subAccountCreatableHandler'
import AssignmentDropdownActions from '@/assignments/AssignmentDropdownActions.vue'

const props = defineProps({
    params: {
        type: Object as () => AssignmentCellRenderParams,
        required: true
    }
})

const panelId: Ref<number> | undefined = inject('panelId')

const assignment = computed<Assignment>(() => {
    return props.params.data as Assignment
})

const actionable = computed<SubAccountCreatable | undefined>(() => {
    return assignment.value.context as SubAccountCreatable
})

const handleAction = () => {
    if (actionable.value) {
        const panel = panelId?.value ? panelId?.value + 1 : undefined
        handleSubAccountCreatable(actionable.value, assignment.value, panel)
    }
}

</script>

<style scoped>

</style>